import React from "react";
import { useSelector } from "react-redux";
import { useGetBooksQuery } from "../../features/api/apiSlice";
import Bookcard from "./Bookcard";

export default function Books() {
  const { data: books, isLoading, isError } = useGetBooksQuery();

  const { filter, search } = useSelector((state) => state.filter);

  const filteredBooks =
    filter === "Featured"
      ? books?.filter((book) => book.featured)
      : search
      ? books?.filter(
          (book) =>
            book.name.toLowerCase().includes(search.toLowerCase()) ||
            book.author.toLowerCase().includes(search.toLowerCase())
        )
      : books;

  // decide what to render
  let content = null;

  if (isLoading) {
    content = <div> Loading... </div>;
  }

  if (!isLoading && isError) {
    content = <div> There was an error occured. </div>;
  }

  if (!isLoading && !isError && filteredBooks?.length === 0) {
    content = <div> No books found! </div>;
  }

  if (!isLoading && !isError && filteredBooks?.length > 0) {
    content = filteredBooks.map((book) => (
      <Bookcard key={book.id} book={book} />
    ));
  }
  return (
    <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
      {/* <!-- Card 1 --> */}
      {content}
    </div>
  );
}
